import { GameConfig } from './GameConfig';
import Player from './Player/Player';
import LevelScene from './Scene/LevelScene';
import PreloadScene from './Scene/PreloadScene';
import SceneManager from './Scene/SceneManager';
import TransitionScene from './Scene/TransitionScene';
import WorldScene from './Scene/WorldScene';
import { GameActions } from './State/Game/GameActions';
import { IGameState } from './State/Game/IGameState';
import StateManager from './State/StateManager';
import RenderSystem from './System/Render/RenderSystem';
import LocaleHandler from './Utility/LocaleManager';
import ResourceManager from './Utility/Resource/ResourceManager';
import SDKManager from './Utility/SDK/SDKManager';
import StyleHandler from './Utility/StyleManager';
import Ticker, { TickerEvent } from './Utility/Ticker';
import { enableTracking } from './Utility/Tracking/DDNA';
import { PlatformActions } from './State/Game/PlatformActions';

export default class Game {
    public static player: Player;
    public static scene: SceneManager;
    public static resource: ResourceManager;
    public static state: StateManager;
    public static locale: LocaleHandler;
    public static style: StyleHandler;
    public static config: GameConfig;
    public static ticker: Ticker;
    public static sdk: SDKManager;

    public static async init(config: GameConfig) {
        Game.config = config;
        Game.state = new StateManager();
        Game.scene = new SceneManager();
        Game.locale = new LocaleHandler();
        Game.style = new StyleHandler();
        Game.resource = new ResourceManager();
        Game.player = new Player();
        Game.ticker = new Ticker();
        Game.sdk = new SDKManager();

        enableTracking();

        await Game.sdk.init();

        Game.ticker.fpsLimit = Game.config.fpsLimit;
        Game.ticker.start();
        Game.state.addListener({
            selector: (state: IGameState) => {
                return state;
            },
            callback: Game.handleStateChanged,
        });

        RenderSystem.init();

        // Start update loop.
        Game.ticker.on(TickerEvent.TICK, this.scene.update.bind(this.scene));

        Game.scene.addScene('Level', new LevelScene());
        Game.scene.addScene('World', new WorldScene());
        Game.scene.addScene('Transition', new TransitionScene());
        Game.scene.addScene('Preload', new PreloadScene());

        await Game.scene.startScene('Preload');
        // Game.sdk.loadingComplete();
    }

    /**
     * Called after initial preload is complete.
     */
    public static start(): void {
        const FTUE = Game.player.getLevelStars(1) === 0;

        if (FTUE) {
            // Has played first level.
            // Load first level.
            Game.state.dispatch(
                GameActions.loadLevel(
                    1,
                    `${Game.config.levelBasePath}/world_1_paris/level_1.json`
                )
            );
        } else {
            // Load active world.
            Game.state.dispatch(
                GameActions.loadWorld(Game.player.getActiveWorldNumber(), false)
            );
        }
    }

    public static handleStateChanged(state: IGameState) {
        // Check if we can start the game.
        if (!Game.state.getPreviousState().gameLoaded && state.gameLoaded) {
            Game.start();
        }

        Game.sdk.handleStateChanged(state);
        Game.player.handleStateChanged(state);
        Game.scene.handleStateChanged(state);
    }
}
